import { FIGURINHA_MAX_BYTES, FIGURINHA_TIPOS_DE_ARQUIVO } from "@foto/shared";

/**
 * O que se confere no celular antes de gastar rede.
 *
 * Só o que dá para saber sem abrir a imagem: o tipo e o peso. Se tem transparência de verdade, só o
 * servidor mede (conta os pixels transparentes); o navegador teria de redesenhar a imagem num canvas, e
 * é justamente isso que `reduzirImagem` faz e que **não** pode ser feito aqui — o canvas devolve o que
 * quiser em cima de um recorte. O arquivo vai cru.
 *
 * As frases são as do servidor, palavra por palavra: quem recebe a recusa antes de enviar e quem a recebe
 * depois leem a mesma coisa.
 */

const MB = 1024 * 1024;

/** Para o `accept` do seletor de arquivos: o sistema operacional já esconde o que não serve. */
export const ACEITA_NO_SELETOR = FIGURINHA_TIPOS_DE_ARQUIVO.join(",");

export const MENSAGEM_DE_TIPO_NAO_ACEITO = "Só PNG ou WebP, com fundo transparente.";

export const MENSAGEM_DE_ARQUIVO_VAZIO = "O arquivo está vazio. Escolha outra imagem.";

export const mensagemDeImagemGrande = (): string =>
  `A imagem passa de ${FIGURINHA_MAX_BYTES / MB} MB.`;

/** `null` quando o arquivo pode ir para o servidor; senão, a frase a mostrar. */
export function conferirArquivo(arquivo: { type: string; size: number }): string | null {
  if (!(FIGURINHA_TIPOS_DE_ARQUIVO as readonly string[]).includes(arquivo.type)) {
    return MENSAGEM_DE_TIPO_NAO_ACEITO;
  }
  if (arquivo.size === 0) return MENSAGEM_DE_ARQUIVO_VAZIO;
  if (arquivo.size > FIGURINHA_MAX_BYTES) return mensagemDeImagemGrande();
  return null;
}
